import themedefault from "./themedefault";

const themes = {
  themedefault
};

export default themes;
